import { axios, Response } from '../index'

export type EditTaskTagRequest = {
  title: string
  hexadecimalColorCode: string
}
export const editTaskTag = (
  editTaskTagRequest: EditTaskTagRequest,
  taskTagId: number
): Response<void> => {
  return axios.put(`/v1/tags/${taskTagId}`, editTaskTagRequest)
}
